import React from 'react';
import type { Color as Interface } from '../../design/components';

export const Color: React.FC<Interface> = ({
  name,
  description,
  state,
  placeholder = 'Select a color',
  hidden,
  inline,
  readonly,
  disabled,
  required,
  error,
}) => {
  const [value, setValue] = state || ['', () => {}];

  // Inline mode: render just the color swatch
  if (inline) {
    return value ? (
      <span
        style={{
          display: hidden ? 'none' : 'inline-block',
          width: '20px',
          height: '20px',
          borderRadius: '4px',
          backgroundColor: value,
          border: '1px solid #ccc',
        }}
      />
    ) : null;
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  const handleClear = (event: React.MouseEvent) => {
    event.stopPropagation();
    setValue('');
  };

  return (
    <div style={{ marginBottom: '1rem', display: hidden ? 'none' : undefined }}>
      <label htmlFor={name} style={{ display: 'block', marginBottom: '4px', fontWeight: 500 }}>
        {name}
        {required && <span style={{ color: 'red' }}> *</span>}
      </label>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          padding: '8px 12px',
          fontSize: '16px',
          border: error ? '1px solid red' : '1px solid #ccc',
          borderRadius: '4px',
          boxSizing: 'border-box',
          backgroundColor: disabled ? '#f5f5f5' : '#fff',
          gap: '8px',
        }}
      >
        <input
          type="color"
          id={name}
          name={name}
          value={value || '#000000'}
          onChange={handleChange}
          disabled={disabled}
          required={required}
          style={{
            width: '32px',
            height: '32px',
            padding: 0,
            border: 'none',
            backgroundColor: 'transparent',
            cursor: readonly || disabled ? 'default' : 'pointer',
          }}
          {...(readonly ? { tabIndex: -1, onMouseDown: (e) => e.preventDefault() } : {})}
        />
        <span style={{ color: value ? 'inherit' : '#999', flex: 1 }}>
          {value || placeholder}
        </span>
        {value && !readonly && !disabled && (
          <button
            type="button"
            onClick={handleClear}
            style={{
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              padding: '2px 6px',
              fontSize: '14px',
              color: '#666',
            }}
            aria-label="Clear color"
          >
            ×
          </button>
        )}
      </div>

      {(error || description) && (
        <small style={{ color: error ? 'red' : '#666', display: 'block', marginTop: '4px' }}>
          {error || description}
        </small>
      )}
    </div>
  );
};
